import { render, staticRenderFns } from "./SubmittedAssessment.vue?vue&type=template&id=67265d68&scoped=true"
import script from "./SubmittedAssessment.vue?vue&type=script&lang=js"
export * from "./SubmittedAssessment.vue?vue&type=script&lang=js"
import style0 from "./SubmittedAssessment.vue?vue&type=style&index=0&id=67265d68&prod&scoped=true&lang=css"
import style1 from "./SubmittedAssessment.vue?vue&type=style&index=1&id=67265d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67265d68",
  null
  
)

export default component.exports